export let props = ['value', 'disabled']
export let model = {}
export let computed = {
  currentValue: {
    get () {
      return this.value
    },
    set (val) {
      if (!val) {
        val = 0
      }
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}